module.exports = "mutation deleteProgramSave($id: Int!) {\n  deleteEntry(id: $id)\n}"